import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { Radio } from "components/common_components/Radio";
import { getFieldError } from "../hooks/fieldUtils";

function RadioField({ fieldName, readOnly, onChange, options, label, helperText }) {
    const onChangeHandler = (event, field, form) => {
        field.onChange(event);
        if (onChange && typeof onChange === "function") {
            onChange(field.name, event && event.target && event.target.checked, form);
        }
    };

    return (
        <Field name={fieldName}>
            {({ field, form }) => (
                <Radio
                    options={options}
                    value={field.value}
                    onChange={(value) => onChangeHandler({ target: { value, name: fieldName } }, field, form)}
                    label={label}
                    readOnly={readOnly}
                    disabled={readOnly}
                    error={getFieldError({ form, field })}
                    helperText={helperText}
                />
            )}
        </Field>
    );
}

RadioField.propTypes = {
    fieldName: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    label: PropTypes.string,
    helperText: PropTypes.string,
};

RadioField.defaultProps = {
    readOnly: false,
    onChange: undefined,
    label: "",
    helperText: undefined,
};

export default RadioField;
